import { FaqSchemaItem, toFaqList } from '../../builders/faq'

export const businessStartupSupportFaqItems: FaqSchemaItem[] = [
  {
    question: '事業構想段階で明確なテーマが決まっていなくても相談可能ですか？',
    answer: 'はい、アイディエーション段階からご支援可能です。仮説構築・ビジネス要求の整理から伴走します。',
  },
  {
    question: 'リサーチやユーザー検証のフェーズだけでも依頼できますか？',
    answer: '可能です。リサーチ・プロトタイプ開発・ユーザーテストなど、フェーズ単位でのご依頼も対応可能です。',
  },
  {
    question: 'MVP開発にはどれくらいの期間がかかりますか？',
    answer: 'プロジェクト内容により異なりますが、平均で3~6ヶ月を目安に短期スプリントでの支援実績があります。',
  },
  {
    question: '社内に開発リソースがないのですが、どこまでお願いできますか？',
    answer:
      '要件定義からデザイン・開発・テストまで、必要に応じてクロスファンクショナルな体制を構築することが可能です。',
  },
]

export const businessStartupSupportFaqList = toFaqList(
  'よくあるご質問',
  '新規事業プロジェクト実行支援に関するよくあるご質問にお答えします',
  businessStartupSupportFaqItems,
)
